import { render } from "./MainDrawer.vue?vue&type=template&id=131ea2ca"
import script from "./MainDrawer.vue?vue&type=script&lang=js"
export * from "./MainDrawer.vue?vue&type=script&lang=js"

import "./MainDrawer.vue?vue&type=style&index=0&id=131ea2ca&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__